<template>
<nav class="container-fluid mb-4 p-2 text-white">
  <div class="container">
    <div class="row">
      <h1 class="col-10 col-sm-12 d-table m-0 p-0">
          <img src="../../assets/logo.png" alt="ohiruneart_logo" class="logo" width="auto" height="60">
          <span class="title d-table-cell col-11 lead text-center text-sm-left">講師用管理画面</span>
        </h1>
      <global-nav-bar-menu/>
    </div>
  </div>
</nav>
</template>

<script>
import NavBar from './GlobalNavBarMenu'
export default {
  components: {
    'global-nav-bar-menu': NavBar
  }
}
</script>



// WEBPACK FOOTER //
// GlobalHeaderBar.vue?2d965df8